export default __webpack_public_path__ + "static/media/Group9412.ba150044.svg";